
function runSparkLayerScripts (cart) {

  function processCartValues (cart) {
      const subtotalElement = document.querySelector("[data-mc-cart-mini-total-toolbar]");
      if (subtotalElement) {
        const formattedAmount = new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: 'AUD',
          minimumFractionDigits: 2,  // Ensure at least two decimal places
          maximumFractionDigits: 2   // Limit to two decimal places
        }).format(cart.subTotal.net);
        subtotalElement.innerText = formattedAmount;
        subtotalElement.style.display = "" // unhide as it is initally hidden to prevent jump from normal to wholesale user
      }
    
      // Update item count element
      const itemCountElement = document.querySelector("[data-cart-mini-count]");
      if (itemCountElement) {
        const totalQuantity = cart.items.reduce((total, item) => total + (item.quantity || 0), 0);
        itemCountElement.innerText = totalQuantity;
        itemCountElement.style.display = "" // unhide as it is initally hidden to prevent jump from normal to wholesale user
      }
    }

  if (cart) {
    processCartValues(cart)
  } else if (spark) {
    spark.getCart().then(processCartValues)  
  }
}

function onReady(callback) {
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(callback, 0); // Ensure callback runs asynchronously
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}


onReady(() => {
  let attempts = 0;
  const maxAttempts = 50; // Stop after 50 tries (~5 seconds at 100ms interval)
  
  const checkSpark = setInterval(() => {
    if (typeof spark !== "undefined") {
      clearInterval(checkSpark);
      runSparkLayerScripts()
    } else {
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(checkSpark);
      }
    }
    }, 100 * attempts);
});